module.exports = __webpack_public_path__ + "img/sec2_1_m.13099238.png";